import { useScreenContentPadding } from '@euler/app/tv/functions/utils';
import { PresentationTheme } from '@euler/app/tv/theme/types';
import { range } from 'ramda';
import { memo } from 'react';
import { ScrollView, StyleProp, View, ViewStyle } from 'react-native';
import { TaskContentLoader } from './TaskContentLoader';

export const TaskListContentLoader = memo(
  ({
    theme,
    cellWidth,
    cellHeight,
    cellMargin,
    numberOfRows = 1,
    style,
  }: {
    theme: PresentationTheme;
    cellWidth: number;
    cellHeight: number;
    cellMargin: number;
    numberOfRows?: number;
    style?: StyleProp<ViewStyle>;
  }) => {
    const [paddingLeft] = useScreenContentPadding();
    return (
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        style={style}
        contentContainerStyle={{
          paddingLeft,
        }}
      >
        {range(0, 6).map(index => (
          <View key={index}>
            {range(0, numberOfRows).map(k => (
              <TaskContentLoader
                key={k}
                width={cellWidth}
                height={cellHeight}
                foregroundColor={theme.dashboard.contentLoader.fg}
                backgroundColor={theme.dashboard.contentLoader.bg}
                style={{ marginRight: cellMargin, marginBottom: cellMargin }}
              />
            ))}
          </View>
        ))}
      </ScrollView>
    );
  },
);
